import React from 'react';

const DAYS = [
  { value: 'monday', label: 'Monday', short: 'Mon' },
  { value: 'tuesday', label: 'Tuesday', short: 'Tue' },
  { value: 'wednesday', label: 'Wednesday', short: 'Wed' },
  { value: 'thursday', label: 'Thursday', short: 'Thu' },
  { value: 'friday', label: 'Friday', short: 'Fri' },
  { value: 'saturday', label: 'Saturday', short: 'Sat' },
  { value: 'sunday', label: 'Sunday', short: 'Sun' },
];

const DaySelector = ({ selectedDay, onSelect, showAll = true }) => {
  return (
    <div 
      className="flex flex-wrap gap-2 justify-center"
      data-testid="day-selector"
    >
      {showAll && (
        <button
          onClick={() => onSelect(null)}
          className={`day-pill px-4 py-2 rounded-full text-sm font-medium transition-all ${
            selectedDay === null
              ? 'bg-[#7B2CBF] text-white border-[#7B2CBF]'
              : 'bg-white text-[#242E30] border-[#E8E8E8] hover:border-[#7B2CBF] hover:text-[#7B2CBF]'
          }`}
          data-testid="day-selector-all"
        >
          All Days
        </button>
      )}
      {DAYS.map((day) => (
        <button
          key={day.value}
          onClick={() => onSelect(day.value)}
          className={`day-pill px-4 py-2 rounded-full text-sm font-medium transition-all ${
            selectedDay === day.value
              ? 'bg-[#7B2CBF] text-white border-[#7B2CBF]'
              : 'bg-white text-[#242E30] border-[#E8E8E8] hover:border-[#7B2CBF] hover:text-[#7B2CBF]'
          }`}
          data-testid={`day-selector-${day.value}`}
        >
          <span className="hidden sm:inline">{day.label}</span>
          <span className="sm:hidden">{day.short}</span>
        </button>
      ))}
    </div>
  );
};

export { DAYS };
export default DaySelector;
